export default class ImageOverVideo {
    constructor() {
        this.init();
    }

    init() {
        this.targetingCookies = window.OptanonActiveGroups && !!(window.OptanonActiveGroups.indexOf('C0004') >= 0);

        if (!this.targetingCookies) {
            $('.module-video').each((index, element) => {
                const $container = $(element);
                const $iframe = $container.find('iframe');
                $container.find('.consent-message').removeClass('hidden');
                $iframe.remove();
            });
        }

        $('.module-video').on('click', '.js-play-video', (e) => {
            if (!this.targetingCookies) {
                e.preventDefault();
                return;
            }
            const $this = $(e.currentTarget);
            const $cover = $this;
            const $container = $this.closest('.module-video');
            const $iframe = $container.find('iframe');

            let src = $iframe.attr('src');
            src += src.indexOf('?') !== -1 ? '&autoplay=1' : '?autoplay=1';
            $iframe.attr('src', src);
            setTimeout(() => {
                $iframe.fadeIn('fast', () => {
                    $cover.fadeOut('fast');
                });
            }, 500);

            return false;
        });
    }
}
